import React from 'react'
import { BuildingsListContainer } from '../BuildingDetailsTab.styles'
import { BuildingCard } from './BuildingCard'
import type { BuildingData } from '../utils/buildingData.utils'

interface BuildingsListProps {
  buildings: BuildingData[]
  expandedBuildings: Set<string>
  onToggleBuilding: (buildingId: string) => void
}

export const BuildingsList: React.FC<BuildingsListProps> = ({
  buildings,
  expandedBuildings,
  onToggleBuilding,
}) => {
  return (
    <BuildingsListContainer>
      {buildings.map((building) => {
        const isExpanded = expandedBuildings.has(building.id)

        return (
          <BuildingCard
            key={building.id}
            building={building}
            isExpanded={isExpanded}
            onToggleExpanded={() => onToggleBuilding(building.id)}
          />
        )
      })}
    </BuildingsListContainer>
  )
}
